
// To add:
// CandidateProfile.js in rightside bar.
// update the ddl in navbar.js
// Add the api Route in the server.js
// Add the CandidateSubscription table in the database

import './CandidateProfile.css';
import { Link, useParams, Navigate, useNavigate, useLocation } from 'react-router-dom';

import { useToast } from '../../CustomeHooks/useToast';
import { useEffect, useRef, useState } from 'react';

import Cookie from 'js-cookie';
import axios from "axios";
import Dialogue from "../Dialogue/Dialogue";

import { isValidToken, getJobCategories } from '../../Javascript_Functions_to_export/Utils';

const CandidateProfile = ({ setLogoFn }) => {

    //console.log("In candidate profile");

    const toast = useToast();
    const { candidateId } = useParams();
    const notifyCandidate = useRef(false);
    
    const [currCandidate, setCurrCandidate] = useState(null);
    const [categories, setCategories] = useState();
    const [openDialog, setOpenDialog] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const location = useLocation();

    axios.defaults.withCredentials = true;
    useEffect(() => {
        var _token = null;
        if(Cookie.get('token'))
            _token = Cookie.get('token');
        else if(Cookie.get('adminToken'))
            _token = Cookie.get('adminToken');

        // User already has logged in, BUT the cookie has expired
        if(!_token && sessionStorage.getItem('Logo')) {
            alert("Session has expired, please Login again");
            sessionStorage.removeItem('Logo');
            window.location.href = process.env.REACT_APP_ORIGIN + "/login";
            return;
        }

        // User has changed or added the token by hand
        if(_token && !isValidToken(_token)) {
            return;
        }

        // user navigate to this page manually (using url)
        if(!location.state && !Cookie.get('token') && !Cookie.get('adminToken')) {
            toast('warning', 'Please login first !');
            if(sessionStorage.getItem('Logo'))
                sessionStorage.removeItem('Logo');
            //navigate('/login');
            // use this line instead of navigate, because it could the cookie expired, 
            // so we need to reload the page to remove the companyLogo
            window.location.href = process.env.REACT_APP_ORIGIN + "/login";
        }
        else {
            // user already was in "CandidatePlan" page, and clicks "Logout"
            if(location && location.state && location.state.LastVisitedPage.indexOf("/candidate/details/") >= 0 && 
                !Cookie.get('token') && !Cookie.get('adminToken')) {
                if(sessionStorage.getItem('Logo'))
                    sessionStorage.removeItem('Logo');
                window.location.href = process.env.REACT_APP_ORIGIN + "/login";
            }
        }

        // Set categories ddl (Like ESFS Othman)
        setCategories(getJobCategories());

        // Get the "Candidate" details
        axios.get(`${process.env.REACT_APP_URL}/getFullCandidate/${ candidateId }`)
        .then(res => {

            if(res.data.status === "success") {
                setCurrCandidate(res.data.candidateFull);
            }
            else {
                toast("error", res.data.message);
            }
        })
        .catch(err => {
            console.log(err);
        })
        .finally(() => {})

        window.scrollTo(0, 0);
    }, []);

    const _planType = useRef(0);  // 0:nothing, 1: basic, 2: pro, 3: premium.
    
    const subscriptionPeriod = 
        //30 * 24 * 3600 * 1000;
        3 * 60 * 60 * 1000;

    // Change here requires changes in server.js (getPlanTypeMessage() function) 
    const subscriptionPlans = [
        {
            id: 1,
            title: "Basic",
            price: "2.00",
            categoryNb: 1,
            totalWhatsappNb: 60,
            region: "Only for opportunities inside lebanon",
            recommended: false,
        },
        {
            id: 2,
            title: "Professional",
            price: "3.00",
            categoryNb: 3,
            totalWhatsappNb: 500,
            region: "For opportunities around the world",
            recommended: true,
        },
        {
            id: 3,
            title: "Premium",
            price: "5.00",
            categoryNb: 5,
            totalWhatsappNb: 1000000,
            region: "For opportunities around the world",
            recommended: false,
        }
    ];

    const showDialog = (e, pPlanType) => {      
        if(e && e.target) {            
            setOpenDialog(true);
            notifyCandidate.current = true;
            _planType.current = pPlanType;
            if (typeof window != 'undefined' && window.document) {
                document.body.style.overflow = 'hidden';
            }
        }
    }

    const closeDialog = (pCloseDialog) => {
        setOpenDialog(false);
        notifyCandidate.current = false;
        // ref: https://medium.com/@nikhil_gupta/how-to-disable-background-scroll-when-a-modal-side-drawer-is-open-in-react-js-999653a8eebb 
        document.body.style.overflow = 'unset';

        // Refresh the candidate, because the "PlanStatus" becomes 1, so update the "Subscription" buttons
        axios.defaults.withCredentials = true;
        // Get the "Candidate" details
        axios.get(`${process.env.REACT_APP_URL}/getFullCandidate/${ candidateId }`)
        .then(res => {
            if(res.data.status === "success")
                setCurrCandidate(res.data.candidateFull);
            else
                toast("error", res.data.message);
        })
        .catch(err => {
            console.log(err);
        })
        .finally(() => { })
    }

    const toggleSubs = (e) => {
        if(e && e.target) {
            axios.defaults.withCredentials = true;
            axios.post(`${process.env.REACT_APP_URL}/toggleSubscription`, 
                { 
                candidateId: candidateId,
                isChecked: e.target.checked,
                planStatus: currCandidate.PlanStatus,
            })
            .then(res => {
                if(res.data.status === 'success') {
                    setCurrCandidate(res.data.candidateFull);
                    if(parseInt(res.data.candidateFull.PlanStatus) === 4) {
                        toast('error', 'Subscription finished.');
                    }
                    else {
                        if(parseInt(res.data.candidateFull.PlanStatus) === 3) 
                            toast('update', 'Subscription paused.');
                        else
                            toast('success', 'Subscription resumed.');
                    }
                }
                else
                    toast("error", res.data.message);
            })
            .catch(err => {
                console.log("err", err);
            })
            .finally(() => {
                setIsSaving(false);
            })
        }
    }

    const Accept = () => {
        console.log("Accept has been clicked");
        return;
        // axios.post(`${process.env.REACT_APP_URL}/subscribe`, 
        //             { 
        //                 candidateId: candidateId, 
        //                 categoryItem: categoryItem 
        //             })
        // .then(res => { 
        // })
        // .catch(err => {
        // });
    }

    // const showInformation = () => {
        
    // }

    return(
        <div className="candidate-profile-container every-page-container">
            {
                currCandidate &&
                <form>
                    <div className='page-container'>

                        <div className='title-section'>
                            <div className='title'>
                                {/* <h2>Candidate Profile</h2> */}
                                <h2>Candidate Plan</h2>
                            </div>
                            <div className='path'>
                                <div className='home'>Menu</div>
                                <div className='circle'></div>
                                {/* <div className='change-password'>Profile</div> */}
                                <div className='change-password'>Plans</div>
                            </div>
                        </div>


                        <div className='content-section'>
                            {
                                currCandidate && 
                                parseInt(currCandidate.PlanStatus) !== 0 ?
                                <div className='paragraph-title'>
                                    Your current plan information:
                                </div>
                                :
                                currCandidate && 
                                parseInt(currCandidate.PlanStatus) === 0 ?
                                <div className='paragraph-title'>
                                    Please choose your plan.
                                </div> : ""
                            }

                            { 
                                currCandidate && 
                                currCandidate.PlanStatus != 0 &&
                                <div className='all-informations'>
                                    {/* <div className='paragraph-title'>
                                        Your current plan information:
                                    </div> */}

                                    <div className='information-part type'>
                                        <div className='left-column default'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 512 512"><path fill='#878787' d="M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"/></svg>
                                        </div>
                                        <div className='right-column'>
                                            <div className='title'>Type</div>
                                            <div className='value'>
                                            {
                                                subscriptionPlans &&
                                                subscriptionPlans.find(g => g.id === currCandidate.PlanType) ?
                                                subscriptionPlans.find(g => g.id === currCandidate.PlanType).title + "." : 
                                                "None"
                                            }
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className='information-part status'>
                                        <div className='left-column'>
                                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 512 512"><path d="M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"/></svg> */}
                                            { 
                                                currCandidate.PlanStatus === 1 ?
                                                <>
                                                    <i className="fa fa-hourglass-half icon" 
                                                        style={{ color: "gray" }}
                                                        aria-hidden="true"></i>
                                                </>
                                                :
                                                currCandidate.PlanStatus === 2 ?
                                                <>
                                                    <i className="fa fa-check-circle-o icon"
                                                        style={{ color: "#00cb00" }}
                                                        aria-hidden="true"></i>
                                                </>
                                                :
                                                currCandidate.PlanStatus === 3 ?
                                                <>
                                                    <i className="fa fa-pause-circle-o icon" 
                                                        style={{ color: "blue" }}
                                                        aria-hidden="true"></i>
                                                </>
                                                :
                                                currCandidate.PlanStatus === 4 ?
                                                <>
                                                    <i className="fa fa-ban icon" 
                                                    style={{ color: "red" }}
                                                    aria-hidden="true"></i>
                                                </>
                                                : ""
                                            }
                                        </div>
                                        <div className='right-column'>
                                            <div className='title'>Status</div>
                                            <div className='value'>
                                            { 
                                                currCandidate.PlanStatus === 1 ?
                                                <div>In Review... your plan will be activated shortly.</div>
                                                :
                                                currCandidate.PlanStatus === 2 ?
                                                <div>Active.</div>
                                                :
                                                currCandidate.PlanStatus === 3 ?
                                                <div>Paused.</div>
                                                :
                                                currCandidate.PlanStatus === 4 ?
                                                <div>Finished.</div>
                                                : ""
                                            }
                                            </div>
                                        </div>
                                    </div>

                                    { 
                                        currCandidate && 
                                        parseInt(currCandidate.PlanStatus) >= 2 &&
                                        <div className='information-part period'>
                                            <div className='left-column'>
                                                <i className="fa fa-calendar icon default" aria-hidden="true"></i>
                                            </div>
                                            <div className='right-column'>
                                                <div className='title'>
                                                { 
                                                    currCandidate && 
                                                    currCandidate.Subs_Code_DateTime && 
                                                    <>Last billing period was</>
                                                }
                                                </div>
                                                <div className='value'>
                                                { 
                                                    currCandidate && 
                                                    currCandidate.Subs_Code_DateTime && 
                                                    <div>
                                                    From&nbsp;
                                                    <font color="red">
                                                    {
                                                        (new Date(currCandidate.Subs_Code_DateTime))
                                                        // .tolocalFormat('%d-%b-%Y')  is not a function
                                                        .toDateString()
                                                        // .toLocaleDateString("en-US", { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' })
                                                    }</font>
                                                    &nbsp;to&nbsp;<font color="red">
                                                    {
                                                        (new Date(new Date(currCandidate.Subs_Code_DateTime)
                                                        .getTime() + subscriptionPeriod)).toDateString() + "."
                                                    }</font>
                                                    </div>
                                                }
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    <div className='information-part categories'>
                                        <div className='left-column'>
                                            <i className="fa fa-th-large icon default" aria-hidden="true"></i>
                                        </div>
                                        <div className='right-column'>
                                            <div className='title'>
                                            {
                                                currCandidate && 
                                                currCandidate.Category &&
                                                <span style={{ 
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    justifyContent: "start",}}
                                                    className='information-part'>
                                                    Selected Categor
                                                    { currCandidate.Category
                                                                .trim()
                                                                .split(",")
                                                                .filter(function(c) { return c })
                                                                .length === 1 ? 'y ' : 'ies '}
                                                </span>
                                            }
                                            </div>
                                            <div className='value selected-categories'>
                                            {
                                                currCandidate && 
                                                currCandidate.Category &&
                                                categories &&
                                                currCandidate.Category
                                                            .trim()
                                                            .split(",")
                                                            .filter(function(c) { return c })
                                                            .map((cat, index) => {
                                                    return(
                                                        <span key={ index } style={{ 
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                            justifyContent: "start",}}>
                                                            <span style={{
                                                                border: "solid 1px #10d210", 
                                                                width:"5px",
                                                                height: "5px",
                                                                borderRadius: "50%",
                                                                backgroundColor: "#10d210",
                                                                display: "inline-block",
                                                                // marginLeft: "10px",
                                                                marginRight:"5px",
                                                            }}>
                                                            </span>
                                                            <span>
                                                                { 
                                                                    categories.find(g => g.Id == cat) ? 
                                                                    categories.find(g => g.Id == cat).Name 
                                                                    : 
                                                                    "Unspecified"
                                                                }
                                                            </span>
                                                        </span>
                                                    )
                                                })
                                            }
                                            </div>
                                        </div>
                                    </div>
                                    
                                    {
                                        currCandidate && 
                                        parseInt(currCandidate.PlanStatus) !== 1 &&
                                        <div className='information-part sent-messages'>
                                            <div className='left-column'>
                                                {/* <i className="fa fa-whatsapp icon" 
                                                style={{color: "#10d210"}} 
                                                aria-hidden="true"></i> */}
                                                <i className="fa fa-envelope-o icon" 
                                                style={{color: "#878787"}} 
                                                aria-hidden="true"></i>
                                            </div>
                                            <div className='right-column'>
                                                <div className='title'>
                                                { 
                                                    currCandidate && 
                                                    currCandidate.PlanType == 3 ? 
                                                    // "Unlimited Messages"
                                                    "Unlimited Emails"
                                                    : 
                                                    // "Sent messages" 
                                                    "Sent Emails" 
                                                }
                                                </div>
                                                <div className='value'>
                                                    {
                                                        currCandidate &&
                                                        currCandidate.PlanType != 3 &&
                                                        subscriptionPlans.find(g => g.id == currCandidate.PlanType) ?
                                                        subscriptionPlans.find(g => g.id == currCandidate.PlanType).totalWhatsappNb - 
                                                        currCandidate.RemainingMessagesNb + " / " +
                                                        subscriptionPlans.find(g => g.id == currCandidate.PlanType).totalWhatsappNb + "."
                                                        : 
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" viewBox="0 0 640 512">
                                                        <path fill="#181818" d="M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5L320 210.7l72.2-72.2C419.5 111.3 456.4 96 494.9 96C575 96 640 161 640 241.1l0 29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2C220.5 400.7 183.6 416 145.1 416C65 416 0 351 0 270.9l0-29.7zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8C100.3 160 64 196.3 64 241.1l0 29.7c0 44.8 36.3 81.1 81.1 81.1c21.5 0 42.2-8.5 57.4-23.8L274.7 256zm90.5 0l72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8c44.8 0 81.1-36.3 81.1-81.1l0-29.7c0-44.8-36.3-81.1-81.1-81.1c-21.5 0-42.2 8.5-57.4 23.8L365.3 256z"/></svg>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    
                                    { 
                                        // try this: Finish the subsc, then comment the 3 lines
                                        // and toggle the subs ==> Solved
                                        currCandidate && 
                                        (parseInt(currCandidate.PlanStatus) === 2 || 
                                        parseInt(currCandidate.PlanStatus) === 3) &&
                                        <div className='information-part toggle-subscription'>
                                            <div className='left-column'>
                                                <i className="fa fa-plug icon default" aria-hidden="true"></i>
                                            </div>
                                            <div className='right-column'>
                                                <div className='title'>
                                                    <label htmlFor='candidateSubscription_id'
                                                            style={{ cursor: 'pointer' }}>
                                                            {/* Pause receiving messages. */}
                                                            Pause receiving emails.
                                                    </label> 
                                                    { /*<i className="fa fa-info-circle" 
                                                        aria-hidden="true"
                                                        style={{ color: "#c5c2c2", cursor: "pointer", marginLeft: "10px"}}
                                                        onClick={ showInformation }></i> */}
                                                </div>
                                                <div className='value'>
                                                    <div>
                                                        <input type="checkbox" 
                                                                name="notifyMe"
                                                                id="candidateSubscription_id"
                                                                className="notify-me" 
                                                                style={{ width: '20px', 
                                                                            height: '20px', 
                                                                            cursor: 'pointer'}}
                                                                checked= { 
                                                                    currCandidate.PauseSubscription 
                                                                }
                                                                value={ currCandidate.PauseSubscription || ""} 
                                                                onChange={ toggleSubs } /> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            
                            {/* Desktop Design */}
                            <div className={`desktop subscriptions-section ${ currCandidate && 
                                                                      currCandidate.PlanStatus === 0 ? 
                                                                      "add-margin" 
                                                                      : 
                                                                      currCandidate && 
                                                                      currCandidate.PlanStatus != 0 ? 
                                                                      ""
                                                                      :
                                                                      ""
                                                                    } `}>

                                {
                                    subscriptionPlans &&
                                    Array.isArray(subscriptionPlans) &&
                                    subscriptionPlans.map((plan, index) => {
                                        return(
                                            <div key={ index } className={`subscription sub-nb${index + 1}`}>
                                                <div className='title' style={{ position: "relative" }}>
                                                    { plan && plan.title }
                                                    {/* { 
                                                        plan && plan.recommended &&
                                                        <><font color="red"> Recommended</font></>
                                                    } */}
                                                    {/* {
                                                        plan && plan && plan.id === 3 &&
                                                        <svg width="30" 
                                                            xmlns="http://www.w3.org/2000/svg" 
                                                            viewBox="0 0 576 512"
                                                            style={{ position: "absolute", 
                                                                    top: "-25px", 
                                                                    right: "60px",
                                                                    
                                                                }}>
                                                        <path fill="#ffd700" d="M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6l277.2 0c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z"/></svg>
                                                    } */}
                                                </div>
                                                <div className='price'>
                                                    <div className='cost'>${ plan.price }</div>
                                                    <div className='time'>per month</div>
                                                </div>
                                                <div className='body'>
                                                    <div className='feature'>
                                                        <i className="fa fa-check" 
                                                            style={{ color: "#10d210" }}
                                                            aria-hidden="true"></i>&nbsp;Receive email&nbsp;
                                                        {/* <i className="fa fa-whatsapp" aria-hidden="true"></i>notifications */}
                                                        for every new posted job in <font color="red">
                                                            { plan.categoryNb } categor
                                                            { plan.categoryNb == 1 ? 'y' : 'ies' }
                                                        </font>.
                                                    </div>
                                                    <div className='feature'>
                                                        <i className="fa fa-check" 
                                                            style={{ color: "#10d210" }}
                                                            aria-hidden="true"></i>&nbsp;
                                                        <span style={{ color:"red",}}>
                                                            { 
                                                                plan.totalWhatsappNb > 10000 ? 
                                                                <><font color="#10d210">Unlimited</font></>
                                                                : 
                                                                plan.totalWhatsappNb
                                                            }
                                                        </span> emails / month.
                                                    </div>
                                                    <div className='feature'>
                                                        <i className="fa fa-check" 
                                                            style={{ color: "#10d210" }}
                                                            aria-hidden="true"></i>&nbsp;{ plan.region }
                                                    </div>
                                                </div>
                                                <div className='footer'>
                                                    <button type='button' 
                                                             className={`btn-plan ${ 
                                                                 currCandidate &&
                                                                ((parseInt(currCandidate.PlanStatus) === 1) || 
                                                                parseInt(currCandidate.PlanStatus) >= 2 && 
                                                                plan.id <= parseInt(currCandidate.PlanType) &&
                                                                ((new Date(currCandidate.Subs_Code_DateTime)
                                                                .getTime() + subscriptionPeriod) > new Date().getTime())) ?
                                                                 'disabled'
                                                                 :
                                                                 ''
                                                            }`}
                                                            disabled={ 
                                                                currCandidate &&
                                                                ((parseInt(currCandidate.PlanStatus) === 1) || 
                                                                parseInt(currCandidate.PlanStatus) >= 2 &&
                                                                plan.id <= parseInt(currCandidate.PlanType) &&
                                                                ((new Date(currCandidate.Subs_Code_DateTime)
                                                                .getTime() + subscriptionPeriod) > new Date().getTime()))
                                                            }
                                                            onClick={ 
                                                                (e) => showDialog(e, plan.id)
                                                                }>
                                                            Choose Plan
                                                        {/* { 
                                                            currCandidate.PlanStatus == 0 ? 
                                                            "Choose Plan"
                                                            :
                                                            currCandidate.planType == plan.id ?
                                                            "Current Plan" :
                                                            "Choose Plan"
                                                        } */}
                                                    </button>
                                                </div>
                                            </div>
                                        )
                                    })
                                }

                            </div>

                            {/* Mobile Design */}
                            <div className={`mobile subscriptions-section ${ currCandidate && 
                                                                      currCandidate.PlanStatus === 0 ? 
                                                                      "add-margin" 
                                                                      : 
                                                                      currCandidate && 
                                                                      currCandidate.PlanStatus != 0 ? 
                                                                      ""
                                                                      :
                                                                      ""
                                                                    } `}>

                                {
                                    subscriptionPlans &&
                                    Array.isArray(subscriptionPlans) &&
                                    subscriptionPlans.map((plan, index) => {
                                        return(
                                            <div key={ index } 
                                                 className={`subscription sub-nb${index + 1}`}
                                                 onClick={ (e) => showDialog(e, plan.id) } >

                                                <div className='title' style={{ position: "relative" }}>
                                                    { plan && plan.title }
                                                    {/* { 
                                                        plan && plan.recommended &&
                                                        <><font color="red"> Recommended</font></>
                                                    } */}
                                                    {/* {
                                                        plan && plan && plan.id === 3 &&
                                                        <svg width="30" 
                                                            xmlns="http://www.w3.org/2000/svg" 
                                                            viewBox="0 0 576 512"
                                                            style={{ position: "absolute", 
                                                                    top: "-25px", 
                                                                    right: "60px",
                                                                    
                                                                }}>
                                                        <path fill="#ffd700" d="M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6l277.2 0c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z"/></svg>
                                                    } */}
                                                </div>
                                                <div className='price'>
                                                    <div className='cost'>${ plan.price }</div>
                                                    <div className='time'>per month</div>
                                                </div>
                                                <div className='body'>
                                                    <div className='feature'>
                                                        <i className="fa fa-check" 
                                                            style={{ color: "#10d210" }}
                                                            aria-hidden="true"></i>&nbsp;Receive email&nbsp;
                                                        {/* <i className="fa fa-whatsapp" aria-hidden="true"></i>notifications */}
                                                        for every new posted job in <font color="red">
                                                            { plan.categoryNb } categor
                                                            { plan.categoryNb == 1 ? 'y' : 'ies' }
                                                        </font>.
                                                    </div>
                                                    <div className='feature'>
                                                        <i className="fa fa-check" 
                                                            style={{ color: "#10d210" }}
                                                            aria-hidden="true"></i>&nbsp;
                                                        <span style={{ color:"red",}}>
                                                            { 
                                                                plan.totalWhatsappNb > 10000 ? 
                                                                <><font color="#10d210">Unlimited</font></>
                                                                : 
                                                                plan.totalWhatsappNb
                                                            }
                                                        </span> emails / month.
                                                    </div>
                                                    <div className='feature'>
                                                        <i className="fa fa-check" 
                                                            style={{ color: "#10d210" }}
                                                            aria-hidden="true"></i>&nbsp;{ plan.region }
                                                    </div>
                                                </div>
                                                {/* <div className='footer'>
                                                    <button type='button' 
                                                             className={`btn-plan ${ 
                                                                 currCandidate &&
                                                                ((parseInt(currCandidate.PlanStatus) === 1) || 
                                                                parseInt(currCandidate.PlanStatus) >= 2 && 
                                                                plan.id <= parseInt(currCandidate.PlanType) &&
                                                                ((new Date(currCandidate.Subs_Code_DateTime)
                                                                .getTime() + subscriptionPeriod) > new Date().getTime())) ?
                                                                 'disabled'
                                                                 :
                                                                 ''
                                                            }`}
                                                            disabled={ 
                                                                currCandidate &&
                                                                ((parseInt(currCandidate.PlanStatus) === 1) || 
                                                                parseInt(currCandidate.PlanStatus) >= 2 &&
                                                                plan.id <= parseInt(currCandidate.PlanType) &&
                                                                ((new Date(currCandidate.Subs_Code_DateTime)
                                                                .getTime() + subscriptionPeriod) > new Date().getTime()))
                                                            }
                                                            onClick={ 
                                                                (e) => showDialog(e, plan.id)
                                                                }>
                                                            Choose Plan
                                                    </button>
                                                </div> */}
                                            </div>
                                        )
                                    })
                                }

                            </div>

                            {/* <div>
                                <button name='saveChanges'
                                    type='button'
                                    onClick={ updateCandidate } 
                                    className={`profile-btn-itself${ isSaving === true || isAddingCV === true ? ' disabled' : ''}`}
                                    disabled={ isSaving === true || isAddingCV === true } >
                                    { 
                                        isAddingCV === true ? 'Save' :
                                        isSaving === true ? 'Saving' : 
                                        'Save'
                                    }
                                </button>
                            </div> */}
                        
                        </div>

                    </div>
                </form>
            }
                
        
            { openDialog && 
                <Dialogue 
                        // message="Please enter your phone number." 
                        // message="Please enter your email." 
                        message="I would like to receive job vacancies on :" 
                        closeFn={ closeDialog } 
                        AcceptFn={ Accept }
                        contBgColor = "rgb(131 130 130 / 63%)" 
                        planType = { _planType.current }
                        _totalWhatsappNb = {
                            subscriptionPlans &&
                            subscriptionPlans.find(g => g.id == _planType.current) ?
                            subscriptionPlans.find(g => g.id == _planType.current).totalWhatsappNb : 0
                        }
                        maxCat = { subscriptionPlans[_planType.current - 1].categoryNb } 
                        // _phoneNumber = { currCandidate.PhoneNumber ? currCandidate.PhoneNumber : "" } 
                        currCandidate = { currCandidate } />
            }

        </div>
    )
}

export default CandidateProfile;